import React from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import styled from "styled-components";

const StyledMenuItem = styled(MenuItem)`
    font-size: 12px;
`;

const EnvironmentSelect = ({ fields, projectsToSetup, setProjectsToSetup, projectName }) => {
    if (!fields) return null;
    const [selectedField, setSelectedField] = React.useState("");

    const handleChange = (event) => {
        const newFieldName = event.target.value;
        setSelectedField(newFieldName);
        const selectedFieldObj = fields.find((field) => field.name === newFieldName);
        const updatedProjects = projectsToSetup.map((project) => {
            if (project.name === projectName) {
                if (selectedFieldObj) {
                    return {
                        ...project,
                        fields: {
                            id: selectedFieldObj.id,
                            name: selectedFieldObj.name,
                        },
                    };
                }
            }
            return project;
        });
        setProjectsToSetup(updatedProjects);
    };

    return (
        <FormControl sx={{ m: 1, minWidth: 250 }} size="small">
            <InputLabel id="demo-select-small-label" sx={{ fontSize: 12 }}>
                Environment
            </InputLabel>
            <Select
                labelId="custom-field"
                id="environment"
                value={selectedField}
                label="Environment"
                sx={{ fontSize: 12 }}
                onChange={handleChange}
            >
                {fields.map((field) => {
                    return <StyledMenuItem value={field.name}>{field.name}</StyledMenuItem>;
                })}
            </Select>
        </FormControl>
    );
};

export default EnvironmentSelect;
